import { Component } from '@angular/core';
import { HOME_CONTENT_MOCK } from '../../data/home-content.mock';

@Component({
  selector: 'app-home-segmentacion',
  templateUrl: './home-segmentacion.component.html',
  standalone: false,
})
export class HomeSegmentacionComponent {
  readonly content = HOME_CONTENT_MOCK.segmentacion;
}
